import { Directive, ElementRef, HostListener, NgModule } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { NgControl } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
class InputPriceDirective {
    constructor(_DecimalPipe, _el, ngControl) {
        this._DecimalPipe = _DecimalPipe;
        this._el = _el;
        this.ngControl = ngControl;
        this.isEleFocus = false;
        _el.nativeElement.style.textAlign = 'right';
        _el.nativeElement.style.paddingRight = '4px';
    }
    ngOnInit() {
        // This for initial: init form before pathchValue
        if (this.ngControl && this.ngControl.control) {
            this.ngControl.control.valueChanges.subscribe(e => {
                if (!this.isEleFocus) {
                    let map = this._el.nativeElement.value;
                    if (typeof map === 'string') {
                        map = +(this._el.nativeElement.value.replace(/,/g, ''));
                    }
                    if (map) {
                        this._el.nativeElement.value = (this._DecimalPipe.transform(map, '1.2-2'));
                    }
                }
            });
        }
        // This for initial: pathchValue before init form
        if (this.ngControl && this.ngControl.value) {
            let map = this.ngControl.value;
            if (typeof map === 'string') {
                map = +(this._el.nativeElement.value.replace(/,/g, ''));
            }
            if (map) {
                this._el.nativeElement.value = (this._DecimalPipe.transform(map, '1.2-2'));
            }
        }
    }
    onInput(value) {
        if (this._el.nativeElement.value != null) {
            const re = /[^0-9.]/g;
            re.test(this._el.nativeElement.value);
            // this.ctrl.setValue(this._el.nativeElement.value.replace(re, ''));
            this._el.nativeElement.value = this._el.nativeElement.value.replace(re, '');
        }
    }
    onFocus() {
        this.isEleFocus = true;
        if (this._el.nativeElement.value != null) {
            if (typeof this._el.nativeElement.value === 'string') {
                this._el.nativeElement.value = this._el.nativeElement.value.replace(/,/g, '');
            }
            if (typeof this._el.nativeElement.value === 'number') {
                this._el.nativeElement.value = this._DecimalPipe.transform(this._el.nativeElement.value, '1.2-2');
            }
        }
    }
    onBlur() {
        this.isEleFocus = false;
        if (this._el.nativeElement.value) {
            if (typeof this._el.nativeElement.value === 'string') {
                this.ngControl.control.setValue(+(this._el.nativeElement.value.replace(/,/g, '')));
                // this._el.nativeElement.value = +(this._el.nativeElement.value.replace(/,/g, ''));
                this._el.nativeElement.value = (this._DecimalPipe.transform(+(this._el.nativeElement.value.replace(/,/g, '')), '1.2-2'));
            }
            else {
                this._el.nativeElement.value = (this._DecimalPipe.transform(this._el.nativeElement.value, '1.2-2'));
            }
        }
    }
}
InputPriceDirective.ɵfac = function InputPriceDirective_Factory(t) { return new (t || InputPriceDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DecimalPipe), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgControl)); };
InputPriceDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: InputPriceDirective, selectors: [["", "inputPrice", ""]], hostBindings: function InputPriceDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function InputPriceDirective_input_HostBindingHandler($event) { return ctx.onInput($event.target.value); })("focus", function InputPriceDirective_focus_HostBindingHandler() { return ctx.onFocus(); })("blur", function InputPriceDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } } });
InputPriceDirective.ctorParameters = () => [
    { type: DecimalPipe },
    { type: ElementRef },
    { type: NgControl }
];
InputPriceDirective.propDecorators = {
    onInput: [{ type: HostListener, args: ["input", ["$event.target.value"],] }],
    onFocus: [{ type: HostListener, args: ["focus",] }],
    onBlur: [{ type: HostListener, args: ["blur",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputPriceDirective, [{
        type: Directive,
        args: [{
                selector: '[inputPrice]'
            }]
    }], function () { return [{ type: ɵngcc1.DecimalPipe }, { type: ɵngcc0.ElementRef }, { type: ɵngcc2.NgControl }]; }, { onInput: [{
            type: HostListener,
            args: ["input", ["$event.target.value"]]
        }], onFocus: [{
            type: HostListener,
            args: ["focus"]
        }], onBlur: [{
            type: HostListener,
            args: ["blur"]
        }] }); })();

class InputPriceFormatModule {
}
InputPriceFormatModule.ɵfac = function InputPriceFormatModule_Factory(t) { return new (t || InputPriceFormatModule)(); };
InputPriceFormatModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: InputPriceFormatModule });
InputPriceFormatModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        DecimalPipe
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputPriceFormatModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    // InputPriceLibComponent,
                    InputPriceDirective
                ],
                imports: [],
                exports: [
                    // InputPriceLibComponent,
                    InputPriceDirective
                ],
                providers: [
                    DecimalPipe
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InputPriceFormatModule, { declarations: [InputPriceDirective], exports: [InputPriceDirective] }); })();

/*
 * Public API Surface of input-price-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InputPriceDirective, InputPriceFormatModule };

